import React from "react";
import { ButtonPrimary, ButtonSecondary } from "../form/button/button.styled";
import { Buttons, Message, Modal } from "./dialog.styled";

const DialogElement = document.getElementById("dialog-confirm");

const Dialog: React.FC<any> = ({
  isOpen,
  title,
  message,
  action,
  onConfirm,
  onDismiss,
  toggle,
  top,
  confirmLabel,
  ...props
}) => {
  return (
    <Modal
      {...props}
      top={top ? top : 10}
      width={500}
      title={title}
      isShown={isOpen}
      toggle={onDismiss}
      target={DialogElement}
    >
      <Message>{message}</Message>
      <Buttons>
        <ButtonSecondary onClick={onDismiss}>Cancelar</ButtonSecondary>
        <ButtonPrimary onClick={onConfirm}>{confirmLabel || 'Enviar'}</ButtonPrimary>
      </Buttons>
    </Modal>
  );
};

export default Dialog;
